import { axiosProvider } from '@/app/core/axios';
import {
  ApiResponse,
  Notification,
  NotificationWithAcceptance,
} from '@ssar-app/domain';

export const getActiveNotifications = (): Promise<
  ApiResponse<NotificationWithAcceptance[]>
> => {
  return axiosProvider.apiClient
    .get(`/notifications/active`)
    .then((response) => response.data);
};

export const getUpcomingNotifications = (): Promise<
  ApiResponse<Notification[]>
> => {
  return axiosProvider.apiClient
    .get(`/notifications/upcoming`)
    .then((response) => response.data);
};

export const getCompletedNotifications = (): Promise<
  ApiResponse<Notification[]>
> => {
  return axiosProvider.apiClient
    .get(`/notifications/completed`)
    .then((response) => response.data);
};

export const saveNotification = (
  notification: Notification,
): Promise<ApiResponse<Notification>> => {
  return axiosProvider.apiClient
    .post<ApiResponse<Notification>>('/notifications/add', notification)
    .then((response) => response.data);
};

export const acceptNotification = (
  notificationIds: string[],
): Promise<ApiResponse<NotificationWithAcceptance>> => {
  return axiosProvider.apiClient
    .post<ApiResponse<NotificationWithAcceptance>>(`/notifications`, {
      notificationIds: notificationIds,
    })
    .then((response) => response.data);
};

export const updateNotification = (
  notification: Notification,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<ApiResponse<any>> => {
  return (
    axiosProvider.apiClient
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .post<ApiResponse<any>>(`/notifications/update/${notification.id}`, {
        ...notification,
        ...{ notify: true },
      })
      .then((response) => response.data)
  );
};

export const deleteNotification = (
  notificationId: string,
): Promise<ApiResponse<Notification>> => {
  return axiosProvider.apiClient
    .delete<ApiResponse<Notification>>(
      `/notifications/delete/${notificationId}`,
    )
    .then((response) => response.data);
};
